import { useAppSelector } from "hooks/store";
import { Navigate, Route, Routes } from "react-router-dom";
import LoginAdmin from "screens/auth/LoginAdmin";
import ToolBar from "components/admin/ToolBar";
import Sidebar from "components/admin/Sidebar";
import AllOrders from "./AllOrders";
import ProjectSetting from "./ProjectSetting";
import TimeSetting from "./TimeSetting";
import InventorySetting from "./InventorySetting";
import CompanyProfile from "./CompnayProfile";
import RestDatesSetting from "./RestDatesSetting";
import DepartmentList from "./DepartmentList";
import DeliveryDistanceCharges from "./DeliveryDistanceCharges";

const AdminContainer = () => {
  const adminData = useAppSelector(({ admin }) => admin.adminData);

  if (!adminData) return <LoginAdmin />;

  return (
    <div className="min-h-screen overflow-hidden bg-gray-50">
      <ToolBar />
      <div className="relative flex h-[calc(100vh-68px)] overflow-hidden">
        <Sidebar />
        <main className="min-w-0 flex-1 overflow-auto">
          <Routes>
            <Route
              path="/admin"
              element={<Navigate to="/admin/setting/time" replace />}
            />
            <Route path="/admin/orders" element={<AllOrders />} />
            <Route path="/admin/setting/project" element={<ProjectSetting />} />
            <Route path="/admin/setting/time" element={<TimeSetting />} />
            <Route path="/admin/inventory" element={<InventorySetting />} />
            <Route path="/admin/CompanyProfile" element={<CompanyProfile />} />
            <Route path="/admin/departments" element={<DepartmentList />} />
            <Route
              path="/admin/delivery-distance"
              element={<DeliveryDistanceCharges />}
            />
            <Route path="/admin/setting/date" element={<RestDatesSetting />} />
            {/* <Route path="/admin/add-image" element={<AddImage />} /> */}
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default AdminContainer;
